/*
 *
 * Email-confirmation reducer (store slice: `signUp`)
 *
 * The in-app sign-up flow this slice was named for is retired, so its
 * SIGN_UP_* / RESEND_VERIFICATION_* cases — and the `signUpSuccessful`,
 * `hasAlreadyBeenTaken`, `email` and `verificationResent` state they wrote —
 * are gone: nothing could dispatch those actions once the form was removed.
 *
 * What is left is load-bearing. ConfirmEmailPage dispatches
 * ACCOUNT_VERIFICATION_REQUEST, its saga resolves it, and the two fields below
 * are what that page renders from (via ./selectors). The slice keeps its
 * `signUp` key in the store for now; renaming it would touch reducers.js and
 * ConfirmEmailPage, and is not part of this cleanup.
 *
 */

import {
  ACCOUNT_VERIFICATION_REQUEST,
  ACCOUNT_VERIFICATION_SUCCESS,
  ACCOUNT_VERIFICATION_FAILURE,
} from './constants';

const initialState = {
  emailConfirmed: null,
  verificationResultPending: false,
};

function emailConfirmationReducer(state = initialState, action) {
  switch (action.type) {
    case ACCOUNT_VERIFICATION_REQUEST:
      return {
        ...state,
        verificationResultPending: true,
      };

    case ACCOUNT_VERIFICATION_SUCCESS:
      return {
        ...state,
        emailConfirmed: true,
        verificationResultPending: false,
      };

    case ACCOUNT_VERIFICATION_FAILURE:
      return {
        ...state,
        emailConfirmed: false,
        verificationResultPending: false,
      };

    // Returns the existing state, not a fresh object. The previous default
    // spread `state` on EVERY dispatched action in order to reset the
    // now-removed `verificationResent` flag, handing the store a new slice
    // reference on every unrelated action in the app.
    default:
      return state;
  }
}

export default emailConfirmationReducer;
